<template>
    <div class="container">
        <div class="container" v-if="action_loading">
            <div class="row">
                <div class="loading-sm"></div>
            </div>
        </div>
        <div v-else class="detail-card" >
            <h5>Transfer Payment Invoice</h5>
            <a v-if="set_select_mode > 0" style="float:right;" @click="set_select_mode = 0; setMenuTabView('','')"> Back</a>
            <div style="clear:both"></div>
            <div v-if="menu_tab_view.selectItemsForInvoice">
                <div v-if="(set_select_mode == 1) && (Object.keys(data_user).length > 0)">
                    <h3>Invoice For: {{ data_user.name }}</h3>
                </div>
                <div v-if="menu_tab_inner_view.previewSelectedItemsForInvoice">
                    <h3>Confirm selected Items</h3>
                    <div>
                        <div v-if="invoice_added_items && (Object.keys(invoice_added_items).length > 0)">
                            <div class="card col-xs-12 card-col-2" v-for="(product,index) in invoice_added_items" :key="index" style="margin-bottom: 2.2em; text-align: left;"> 
                                <!-- <a @click="setProduct(product.product_data)" style="text-decoration: none; color:inherit;"> -->
                                <!-- <span class="card-thumb-up-left"><i class="fa fa-shopping-bag"></i></span> -->
                                <div class="col-xs-4 card-col-img" style="">
                                    <img v-if="product.product_data.product_images[0]" :src="product.product_data.product_images[0].product_image" class="img-responsive" style="max-height:8em;">
                                    <img v-else src="/static/assets/images/dummy-image.png" class="img-responsive" style="max-height:8em;">
                                </div>
                                <div class="col-xs-8 card-col-details" style="display:block; padding: 3px;">
                                    <p style="font-size:13px; text-align: left;" class="prd-name">{{product.product_data.product_name}}<br>
                                        <span class="sp-app-default-color" style="font-weight:bolder;">₦{{product.product_item_price_f}}</span><br>
                                        <span>Quantity: <input type="number" v-model="product.order_item_order_quantity"/></span>
                                    </p>
                                </div>
                                <!-- </a> -->
                                <div style="clear: both;"></div>
                            </div>
                            <div>
                                <a class="btn sp-button-02" @click="generatePaymentOrders">Generate Invoice</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p>Add items to Invoice</p>
                    <!-- {{ invoice_added_items }} -->
                    <hr/>
                    <div class="container" v-if="data_loading.products">
                        <div class="row">
                            <div class="loading-sm"></div>
                            <p style="color:#ff0000">loading products...</p>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="products && (Object.keys(products).length > 0)">
                            <div class="card col-xs-4 card-col-2" v-for="(product,index) in products" :key="index" style="margin-bottom: 2.2em; min-height:15em; max-height:15em;"> 
                                <a @click="setProduct(product)" style="text-decoration: none; color:inherit;">
                                <!-- <span class="card-thumb-up-left"><i class="fa fa-shopping-bag"></i></span> -->
                                <div class="card-col-img" style="">
                                    <img v-if="product.product_images[0]" :src="product.product_images[0].product_image" class="img-responsive" style="max-height:8em;">
                                    <img v-else src="/static/assets/images/dummy-image.png" class="img-responsive" style="max-height:8em;">
                                </div>
                                <div class="card-col-details" style="display:block; padding: 3px;">
                                    <p style="font-size:13px; text-align: center;" class="prd-name">{{product.product_name}}<br>
                                        <span v-if="product.product_items[0]" class="sp-app-default-color" style="font-weight:bolder;">₦{{product.product_items[0].product_item_price_f}}</span>
                                    </p>
                                </div>
                                </a>
                                <div class="add-pad">
                                    <div v-if="isItemInList(product.product_items[0])">
                                        <input type="checkbox" :checked="true"  @click="removeItemsFromInvoice(product.product_items[0])"/> Added
                                    </div>
                                    <div v-else>
                                        <input v-if="!(isItemInList(product.product_items[0]))" type="checkbox" @click="addItemsToInvoice(product.product_items[0],product)"/> Add
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                        <div v-else>
                            <p style="color:#ff0000">No products yet</p>
                            <a href="/account/business/newproduct" class="btn sp-vutton-02">Add Products</a>
                        </div>
                    </div>
                    <hr/>
                    <div style="clear: both;"></div>
                    <div class="row" v-if="(Object.keys(invoice_added_items).length > 0)" style="bottom:1em; background-color:#ff0000; height: 2em;">
                        <a class="btn sp-button-02" @click="setMenuTabInnerView('previewSelectedItemsForInvoice')">Add ({{ Object.keys(invoice_added_items).length }}) Item(s) to Invoice</a>
                    </div>
                </div>
            </div>
            <div v-else>
                <p>Generate and send Transfer Invoice to a customer or more than one customer. Customers who 
                    click on the link can quickly make transfers directly to your bank account for products you 
                    added to the invoice.</p>
                <hr/>
                <h5>Generate invoice:</h5>
                <div>
                    <input type="radio" v-model="set_select_mode" value="1" @click="setMenuTabInnerView('one_customer')"/> For One Customer<br>
                    <input type="radio" v-model="set_select_mode" value="2" @click="setMenuTabView('','selectItemsForInvoice')"/> General - Anyone can pay<br>
                </div>
                <div v-if="menu_tab_inner_view.one_customer" style="margin-top:1em;">
                    <div class="form-group">
                        <label>Customer's eShop username or phone number or email</label>
                        <p v-if="data_error_message != ''">{{ data_error_message }}</p>
                        <input type="text" v-model="customer.custormer_name" class="form-control" placeholder="">
                    </div>
                    <div class="form-group">
                        <button :disabled="disable_btn" type="button" class="btn sp-button-02 sp-button-sm"  @click="getUsersDetails(customer.custormer_name,customer,'get_customer_details_for_invoice_request')">Enter</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .add-pad{
        display: inline-block;
        vertical-align: middle;
        border-style: solid;
        border-width: 1px;
        border-color: #dddbdc;
        border-radius: 2px;
        background-color: none;
        box-shadow: none;
        color: #000000;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 10px;
        transition: all .4s ease;
    }
</style>

<script>
    
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
                set_select_mode:false,
            }
        },
        methods: {
            setPage(){
                this.action_loading = true; //using *action_loading as *loading may be in use by loadCategories
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        //get sp data
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        //if no sp data
                        if((self.sellpoint == null) || (self.sellpoint == undefined)){
                            //call loadAccountBase*
                            self.loadAccountBase();
                        }else{
                            self.products =  value.account.store_sellpoint.store_products;
                            if(self.products == undefined || (Object.keys(self.products).length == 0)){
                                self.getSellpointProducts();
                            }else{
                                self.action_loading = false;
                            }
                            //
                            self.setDynamicRequests();                                    
                        }
                        // //check for sps
                        // //let sellpoints = this.$store.getters['account/getUserBusinesses'];
                        // let sellpoints = value.account.store_sellpoints;
                        // //if no sps
                        // if((sellpoints == null) || (sellpoints == undefined)){
                        //     //call loadAccountBase
                        //     self.loadAccountBase();
                        // }else{
                        //     //if more than one
                        //     if(Object.keys(sellpoints).length > 0){
                        //         //redir to sps
                        //         location.replace("/account/businesses");
                        //     }else{
                        //         //else if one sp
                                
                        //     }
                        // }
                    }else{}
                });
            },

            setDynamicRequests(){
                ///terminate any active dynamic request
                let self = this;
                localforage.removeItem(self.getService.adr_db_name).then(function (value) {}).catch(function(err) {});
            },
        },

        created: function(){
            this.setPage();
        }

    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// GenerateTransferPayment.vue?0ca39793